import React from "react";
import loadjs from "loadjs";
import { WeaTools } from "ecCom";

const id = Math.random()
  .toString(36)
  .substr(2);

const configTable = {
  DialogComponent: ["remind", "消息中心-小喇叭"],
  FixedPop: ["rightBottom", "消息中心-右下角"],
  MessageComponent: ["messageComponent", ""],
  IntervalTime: ["intervalTime"],
  AutoCloseTime: ["autoCloseTime"]
};
const getValve = params => {
  return WeaTools.callApi("/api/msgcenter/config/getValve", "GET", params);
};

function AsyncIndex(WrappedComponent, funName) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        valid: false,
        intervalTime: 10,
        autoCloseTime: 10
      };
    }

    componentDidMount() {
      this.globalConfig();
    }

    globalConfig() {
      let valid = this.state.valid;
      getValve({
        // 请求来自前台页面，不返回后台权限配置信息
        source: "front"
      })
        .then(res => {
          const configValue = {
            remind: res.remind === "1",
            rightBottom: res.rightBottom === "1",
            intervalTime: Number(res.intervalTime),
            autoCloseTime: Number(res.autoCloseTime),
            messageComponent: true
          };
          valid = this.isGlobalConfigValid(funName, configValue);
          const intervalTime = this.isGlobalConfigValid(
            "IntervalTime",
            configValue
          );
          const autoCloseTime = this.isGlobalConfigValid(
            "AutoCloseTime",
            configValue
          );
          this.setState({ valid, intervalTime, autoCloseTime });
        })
        .catch(res => {
          valid = this.isGlobalConfigValid(funName, {
            remind: false,
            rightBottom: false,
            intervalTime: 10,
            autoCloseTime: 10
          });
          this.setState({ valid });
        });
      // deparate
      // if (!this.isGlobalConfigValid()) {
      //   loadjs("/spa/coms/ssoConfig/config.js", res => {
      //     valid = this.isGlobalConfigValid(funName);
      //     this.setState({ valid });
      //   });
      // }
    }

    isGlobalConfigValid(configName, configValue) {
      let result = false;
      if (configName && configTable[configName] === undefined) {
        // console.warn(configName, "configTable 组件配置缺失，请检查");
        result = false;
      }

      let valid = this.state.valid;
      if (configName !== undefined) {
        valid = configValue[configTable[configName][0]];
        // console.log(configTable[configName][0], configName, valid);
        if (typeof valid === "number" || typeof valid === "boolean") {
          result = valid;
        } else {
          result = false;
        }
      }

      // if (result && typeof result === "boolean") {
      //   // 开放 subcompanyid 名单
      //   const subcompanyidWhiteList = [157, 0];
      //   try {
      //     let account = window.localStorage.getItem("theme-account");
      //     account = JSON.parse(account);
      //     if (account && !isNaN(account.subcompanyid)) {
      //       result = subcompanyidWhiteList.includes(
      //         Number(account.subcompanyid)
      //       );
      //     }

      //     // 给测试账号留的后门
      //     if (
      //       window.localStorage.getItem("test-message-center-config") === "1"
      //     ) {
      //       result = true;
      //     }
      //   } catch (err) {}
      // }

      return result;
    }

    render() {
      const { intervalTime, autoCloseTime } = this.state;
      return this.state.valid ? (
        <WrappedComponent
          id={id}
          {...this.props}
          intervalTime={intervalTime < 10 ? 10 * 1000 : intervalTime * 1000}
          autoCloseTime={autoCloseTime < 60 ? 60 * 1000 : autoCloseTime * 1000}
        />
      ) : null;
    }
  };
}

export default AsyncIndex;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/async-hoc.js